// Authentication API

import { ApiClient } from '@/lib/axios/client';
import type { AuthResponse, OTPVerifyResponse, User, UserOrg } from './types';

const BASE_PATH = '/api/v1/auth';

export class AuthApi {
  /**
   * Send OTP to user's phone number
   */
  static async login(mobile: string, stdCode: string): Promise<AuthResponse> {
    return await ApiClient.post<AuthResponse>(`${BASE_PATH}/send-code`, {
      phone_number: mobile,
      country_code: stdCode,
    });
  }

  /**
   * Verify OTP and authenticate user
   */
  static async verifyOTP(
    mobile: string,
    stdCode: string,
    otp: number
  ): Promise<OTPVerifyResponse> {
    return await ApiClient.post<OTPVerifyResponse>(`${BASE_PATH}/login`, {
      phone_number: mobile,
      country_code: stdCode,
      otp,
    });
  }

  /**
   * Logout user
   */
  static async logout(): Promise<void> {
    await ApiClient.post(`${BASE_PATH}/logout`);
  }

  /**
   * Get current user details
   */
  static async getMe(): Promise<User> {
    return await ApiClient.get<User>(`${BASE_PATH}/me`);
  }

  /**
   * Switch organization and get user permissions for the new org
   */
  static async switchOrg(orgId: string): Promise<UserOrg> {
    return await ApiClient.post<UserOrg>(`${BASE_PATH}/switch-org`, {
      org_id: orgId,
    });
  }
}
